import styled from "styled-components";

export const ExtraLargeHeader = styled.h1`
  font-size: 4rem;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  margin: 0;

  @media (max-width: 520px) {
    font-size: 3rem;
  }
  @media (min-width: 2500px) {
    font-size: 5rem;
  }
  @media (min-width: 3400px) {
    font-size: 6rem;
  }
  @media (min-width: 3800px) {
    font-size: 6.5rem;
  }
  @media (min-width: 4500px) {
    font-size: 7rem;
  }
  @media (min-width: 5000px) {
    font-size: 8.5rem;
  }
`;

export const SectionHeader = styled.h1`
  font-size: ${({ theme }) => theme.typography.h1.fontSize};
  font-weight: ${({ theme }) => theme.typography.h1.fontWeight};
  margin: 0;
  text-transform: uppercase;
  word-spacing: ${({ theme }) => theme.spacing.xsmall};

  @media (max-width: 520px) {
    font-size: 2.5rem;
  }
  @media (min-width: 2500px) {
    font-size: 4rem;
  }
  @media (min-width: 3400px) {
    font-size: 5.25rem;
    word-spacing: ${({ theme }) => theme.spacing.small};
  }
  @media (min-width: 3800px) {
    font-size: 5.75rem;
  }
  @media (min-width: 4500px) {
    font-size: 6.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 6.75rem;
  }
`;

export const LargeTextLight = styled.h1`
  font-size: ${({ theme }) => theme.typography.h1.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.light};
  margin: 0;
  line-height: 2.75rem;

  @media (max-width: 1024px) {
    font-size: 2.5rem;
  }
  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.h2.fontSize};
    line-height: 2.15rem;
  }
  @media (min-width: 2500px) {
    line-height: 3.75rem;
    font-size: 4rem;
  }
  @media (min-width: 3400px) {
    line-height: 5rem;
    font-size: 5.25rem;
  }
  @media (min-width: 3800px) {
    line-height: 5.5rem;
    font-size: 5.75rem;
  }
  @media (min-width: 4500px) {
    line-height: 6rem;
    font-size: 6.25rem;
  }
  @media (min-width: 5000px) {
    line-height: 6.5rem;
    font-size: 6.75rem;
  }
`;

export const SectionHeaderSemibold = styled.h1`
  font-size: ${({ theme }) => theme.typography.h1.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  margin: 0;
  text-transform: uppercase;
  word-spacing: ${({ theme }) => theme.spacing.xsmall};

  @media (max-width: 520px) {
    font-size: 2.5rem;
  }
  @media (min-width: 2500px) {
    font-size: 4rem;
  }
  @media (min-width: 3400px) {
    font-size: 5.25rem;
  }
  @media (min-width: 3800px) {
    font-size: 5.75rem;
  }
  @media (min-width: 4500px) {
    font-size: 6.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 6.75rem;
  }
`;

export const H2 = styled.h2`
  font-size: ${({ theme }) => theme.typography.h2.fontSize};
  font-weight: ${({ theme }) => theme.typography.h2.fontWeight};
  margin: 0;

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.body.fontSize};
  }

  @media (min-width: 2500px) {
    font-size: 2.75rem;
  }
  @media (min-width: 3400px) {
    font-size: 3.25rem;
  }
  @media (min-width: 3800px) {
    font-size: 3.75rem;
  }
  @media (min-width: 4500px) {
    font-size: 4.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 4.75rem;
  }
`;

export const MediumHeader = styled.h2`
  font-size: ${({ theme }) => theme.typography.h2.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  margin: 0;
  word-break: break-word;
  word-spacing: ${({ theme }) => theme.spacing.xsmall};

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.body.fontSize};
  }
  @media (min-width: 2500px) {
    font-size: 2.75rem;
  }
  @media (min-width: 3400px) {
    font-size: 3.25rem;
  }
  @media (min-width: 3800px) {
    font-size: 3.75rem;
  }
  @media (min-width: 4500px) {
    font-size: 4.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 4.75rem;
  }
`;

export const MediumHeaderSemiold = styled.h2`
  font-size: ${({ theme }) => theme.typography.h2.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  margin: 0;
  word-break: break-word;

  @media (max-width: 520px) {
    font-size: 1.5rem;
  }
  @media (min-width: 2500px) {
    font-size: 2.75rem;
  }
  @media (min-width: 3400px) {
    font-size: 3.25rem;
  }
  @media (min-width: 3800px) {
    font-size: 3.75rem;
  }
  @media (min-width: 4500px) {
    font-size: 4.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 4.75rem;
  }
`;

export const MediumHeaderBold = styled.h2`
  font-size: ${({ theme }) => theme.typography.h2.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin: 0;
  word-break: break-word;

  @media (max-width: 520px) {
    font-size: 1.5rem;
  }
  @media (min-width: 2500px) {
    font-size: 2.75rem;
  }
  @media (min-width: 3400px) {
    font-size: 3.25rem;
  }
  @media (min-width: 3800px) {
    font-size: 3.75rem;
  }
  @media (min-width: 4500px) {
    font-size: 4.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 4.75rem;
  }
`;

export const MediumHeaderExtraBold = styled.h2`
  font-size: ${({ theme }) => theme.typography.h2.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.extrabold};
  margin: 0;
  word-break: break-word;

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.body.fontSize};
  }
  @media (min-width: 2500px) {
    font-size: 2.75rem;
  }
  @media (min-width: 3400px) {
    font-size: 3.25rem;
  }
  @media (min-width: 3800px) {
    font-size: 3.75rem;
  }
  @media (min-width: 4500px) {
    font-size: 4.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 4.75rem;
  }
`;

export const PageSubheader = styled.h3`
  font-size: ${({ theme }) => theme.typography.h3.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  margin: 0;
  white-space: pre-line;

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.body.fontSize};
  }
  @media (min-width: 2500px) {
    font-size: 2.25rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.75rem;
  }
  @media (min-width: 3800px) {
    font-size: 3.25rem;
  }
  @media (min-width: 4500px) {
    font-size: 3.75rem;
  }
  @media (min-width: 5000px) {
    font-size: 4.25rem;
  }
`;

export const BodyText = styled.p`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  margin: 0;

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};
  }
  @media (min-width: 2500px) {
    font-size: 1.75rem;
  }
  @media (min-width: 3000px) {
    font-size: 2rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.5rem;
  }
  @media (min-width: 3800px) {
    font-size: 3rem;
  }
  @media (min-width: 4500px) {
    font-size: 3.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 3.75rem;
  }
`;

export const BodyTextBold = styled.p`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin: 0;

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};
  }
  @media (min-width: 2500px) {
    font-size: 1.75rem;
  }
  @media (min-width: 3000px) {
    font-size: 2rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.5rem;
  }
  @media (min-width: 3800px) {
    font-size: 3rem;
  }
  @media (min-width: 4500px) {
    font-size: 3.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 3.75rem;
  }
`;

export const BodyTextSemibold = styled.p`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  margin: 0;

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};
  }
  @media (min-width: 2500px) {
    font-size: 1.75rem;
  }
  @media (min-width: 3000px) {
    font-size: 2rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.5rem;
  }
  @media (min-width: 3800px) {
    font-size: 3rem;
  }
  @media (min-width: 4500px) {
    font-size: 3.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 3.75rem;
  }
`;

export const MediumText = styled.p`
  font-size: ${({ theme }) => theme.typography.medium.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  margin: 0;

  @media (min-width: 2500px) {
    font-size: 1.5rem;
  }
  @media (min-width: 3000px) {
    font-size: 1.75rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.25rem;
  }
  @media (min-width: 3800px) {
    font-size: 2.575rem;
  }
  @media (min-width: 4500px) {
    font-size: 3rem;
  }
  @media (min-width: 5000px) {
    font-size: 3.5rem;
  }
`;

export const RegularText = styled.p`
  font-size: ${({ theme }) => theme.typography.regular.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  margin: 0;

  @media (min-width: 2500px) {
    font-size: 1.25rem;
  }
  @media (min-width: 3000px) {
    font-size: 1.5rem;
  }
  @media (min-width: 3400px) {
    font-size: 1.75rem;
  }
  @media (min-width: 3800px) {
    font-size: 2.25rem;
  }
  @media (min-width: 4500px) {
    font-size: 2.75rem;
  }
  @media (min-width: 5000px) {
    font-size: 3.25rem;
  }
`;

export const SmallText = styled.p`
  font-size: ${({ theme }) => theme.typography.small.fontSize};
  font-weight: ${({ theme }) => theme.typography.small.fontWeight};
  margin: 0;

  @media (min-width: 2500px) {
    font-size: 0.875rem;
  }
  @media (min-width: 3400px) {
    font-size: 1.25rem;
  }
  @media (min-width: 3800px) {
    font-size: 1.75rem;
  }
  @media (min-width: 4500px) {
    font-size: 2.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 2.75rem;
  }
`;
